// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"116":"5be27c5c","141":"31e71487","487":"a3bdca36","686":"2e571c88","780":"d32acece"}[chunkId] + ".chunk.css";
};